import React, { useState, useEffect, useCallback } from "react";
import TopHeader from "../../../Component/Header/TopHeader";
import { Box, Button, Divider, Typography, Modal } from "@mui/material";
import { IconButton } from "@mui/material";
import {
  usePaginationGalleryMutation,
  useDeleteGalleryMutation, useLazyGetEnableDisableGalleryQuery
} from "../../../app/services/galleryService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate, Link } from "react-router-dom";
import "../../../style/css/pagination.css";
import ReactPaginate from "react-paginate"; // Import CSS file for pagination styles
import "./GalleryTable.css";
import { selectCurrentScope, selectUserId } from "../../../app/auth/authSlice";
import { useSelector } from "react-redux";
import Spinner from "../../../Component/spinner/spinner";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";
import Tooltip from "@material-ui/core/Tooltip";
import GetChapterName from "../../../Component/HomePage/GetChapterName";
import GetSIGName from "../../../Component/HomePage/GetSigName";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DOMPurify from "dompurify";
import CloseIcon from "@mui/icons-material/Close";
import { selectCurrenChapterRole } from "../../../app/features/chapterAdminSlice";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";



//table Property
function EnhancedTableHead() {
  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Gallery Image",
    },
    {
      id: "calories",
      numeric: true,
      disablePadding: false,
      label: "Album Name",
    },
    {
      id: "createdBy",
      numeric: true,
      disablePadding: false,
      label: "Created by",
    },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

const GalleryTable = () => {
  const [loading, setLoading] = useState(false);
  const memberScope = useSelector(selectCurrentScope);
  const userId = useSelector(selectUserId);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  let [totalCount, setTotalCount] = useState(0);
  const [getAllGallerys, setGetAllGallerys] = useState([]);
  const navigate = useNavigate();
  const [PaginationGallery] = usePaginationGalleryMutation();
  const [deleteGallery] = useDeleteGalleryMutation();
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");


  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setError("");
    // setPage(selected);

  };
  const [open, setOpen] = useState(false);


  const [deleteGalleryId, setDeleteGalleryId] = useState(null);
  const roleDetails = useSelector(selectCurrenChapterRole);
  const [enableDisableGallery] = useLazyGetEnableDisableGalleryQuery();


  const handleOpen = (id) => {
    setOpen(true);
    setDeleteGalleryId(id);
  };

  const handleClose = () => setOpen(false);


  const sanitizeEditorContent = (html) => {
    // Allow only specific tags for styles (e.g., b, i, u, strong, em)
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ["b", "i", "u", "strong", "em"],
      ALLOWED_ATTR: [], // Disallow all attributes
    });
  };

  //Get all events list
  const getAllPagination = useCallback(() => {
    var data = {
      page: currentPage + 1,
      itemsPerPage: itemsPerPage,
      role: memberScope ? memberScope : "",
    };
    PaginationGallery(data)
      .unwrap()
      .then((res) => {
        if (res.status) {
          setLoading(false)
          setGetAllGallerys(res.data.galleryDetails);
          setTotalCount(res?.data?.totalCount)
        }
        else {
          setLoading(false);
          // toast.error(res?.err?.message)
        }
      });
  }, [PaginationGallery, currentPage, itemsPerPage, memberScope]);


  //paginationGallery
  useEffect(() => {
    getAllPagination()
  }, [getAllPagination]);

  // const tota = Math.ceil(totalCount / itemsPerPage);
  const pageCount = Math.ceil(totalCount / itemsPerPage);
  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setCurrentPage(pageNumber - 1);
    }
  };

  //delete function for testimonial
  const handleDelete = () => {
    setLoading(true);
    deleteGallery({ galleryId: deleteGalleryId }).then((res) => {
      if (res.data?.status) {
        setLoading(false);
        toast.success(res?.data?.message);
        handleClose();
        if (getAllGallerys.length <= 1) {
          setCurrentPage(currentPage - 1)
          getAllPagination()
        } else {
          getAllPagination()
        }
      } else {
        setLoading(false);
        // toast.error(res.data?.err?.message);
      }
    });
  };

  // Enable/Disable
  const handleEnableDisable = (id) => {
    enableDisableGallery(id)
      .then((res) => {
        if (res?.data?.data?.isDeleted === 0) {
          getAllPagination()
          toast.success(res?.data?.message);
        } else {
          getAllPagination()
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //handleView 
  const handleView = (id) => {
    if (id && memberScope === "PORTAL_SUPER_ADMIN") {
      navigate(`/admin/showGallery/${id}`);
    } else if (id && memberScope === "PORTAL_SIG_ADMIN") {
      navigate(`/sigAdmin/showGallery/${id}`);
    } else if (id && memberScope === "PORTAL_CHAPTER_ADMIN") {
      navigate(`/chapterAdmin/showGallery/${id}`);
    } else if (id && memberScope === "PORTAL_MEMBER") {
      navigate(`/member/showGallery/${id}`);
    } else if (id && memberScope === "PORTAL_ADMIN") {
      navigate(`/assistantAdmin/showGallery/${id}`);
    }
  };
  const handleEdit = (id) => {
    if (memberScope === "PORTAL_SUPER_ADMIN") {
      navigate(`/admin/add-edit-Gallery/${id}`);
    } else if (memberScope === "PORTAL_SIG_ADMIN") {
      navigate(`/sigAdmin/add-edit-Gallery/${id}`);
    } else if (memberScope === "PORTAL_CHAPTER_ADMIN") {
      navigate(`/chapterAdmin/add-edit-Gallery/${id}`);
    } else if (memberScope === "PORTAL_MEMBER") {
      navigate(`/member/add-edit-Gallery/${id}`);
    } else if (memberScope === "PORTAL_ADMIN") {
      navigate(`/assistantAdmin/add-edit-Gallery/${id}`);
    }
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    minWidth: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
  };
  return (
    <div>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Gallery List</h2>
        </div>
      </div>
      <div className="p-md-1 p-3 overallPadding">
        <div className="text-end w-100" style={{ marginBottom: "15px" }}>
          <Link
            to={
              memberScope === "PORTAL_SUPER_ADMIN"
                ? "/admin/add-edit-Gallery"
                : memberScope === "PORTAL_ADMIN"
                  ? "/assistantAdmin/add-edit-Gallery"
                  : memberScope === "PORTAL_SIG_ADMIN"
                    ? "/sigAdmin/add-edit-Gallery"
                    : "/chapterAdmin/add-edit-Gallery"
            }
          >
            <Button
              variant="contained"
              style={{ marginRight: "5px" }}
              className="justify-content-end menus-color"
            >
              Add Gallery
            </Button>
          </Link>
        </div>
        {loading ? (
          <Spinner />
        ) : (
          <div>
            <Box >
              <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                  <EnhancedTableHead />
                  <TableBody>
                    {getAllGallerys.length > 0 ?
                      getAllGallerys
                        .map((galery, index) => (
                          <TableRow
                            hover
                            key={index}
                            sx={{
                              cursor: "pointer",
                              backgroundColor:
                                index % 2 === 0 ? "#f0f0f0" : "white",
                            }}

                          >
                            <TableCell align="center">
                              <img
                                src={galery?.list[0]?.imageUrl}
                                width={"150px"}
                                height={"150px"}
                                alt="gallery"
                              />
                            </TableCell>
                            <TableCell align="center"
                              className="text-truncate"
                              style={{
                                maxWidth: "140px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer",
                              }}
                              title={sanitizeEditorContent(galery?.category)} // Adds sanitized content as a tooltip
                              dangerouslySetInnerHTML={{
                                __html: sanitizeEditorContent(galery?.category).slice(0, 50) + "...", // Truncated sanitized content
                              }}>
                            </TableCell >
                            <TableCell align="center">
                              {galery?.createdBy?.role === "PORTAL_SUPER_ADMIN" ||
                                galery?.createdBy?.role === "PORTAL_ADMIN" ? (
                                "ELTAI"
                              ) : galery?.createdBy?.role ===
                                "PORTAL_CHAPTER_ADMIN" ? (
                                <GetChapterName id={galery?.createdBy?.id} />
                              ) : (
                                <GetSIGName id={galery?.createdBy?.id} />
                              )}</TableCell>
                            <TableCell align="center">
                              <Tooltip title="View">
                                <IconButton aria-label="view" onClick={() => { handleView(galery._id) }}>
                                  <VisibilityIcon className="icon-vieweye-color" />
                                </IconButton>
                              </Tooltip>
                              {(memberScope === "PORTAL_SUPER_ADMIN" ||
                                memberScope === "PORTAL_ADMIN"
                                ?
                                galery.isApproved !== ''
                                : Object.keys(roleDetails).length !== 0
                                  ? galery.createdBy.id === userId &&
                                  galery.isApproved !== 1
                                  : galery.createdBy.id === userId &&
                                  galery.isApproved !== 1) && (
                                  <>
                                    {!(galery.isDeleted === 2) && (
                                      <Tooltip title="Edit">
                                        <IconButton aria-label="edit" onClick={() => { handleEdit(galery._id) }}>
                                          <EditIcon style={{ color: "green" }} />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {galery?.isDeleted === 0 ? (
                                      <Tooltip title="Enable" >
                                        <IconButton
                                          aria-label="enable"
                                          onClick={() => {
                                            handleEnableDisable(galery._id);
                                          }}
                                        >
                                          <LockOpenIcon
                                            style={{ color: "green" }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    ) : galery?.isDeleted === 2 ? (
                                      <Tooltip
                                        title="Disable"
                                       
                                      >
                                        <IconButton
                                          aria-label="disable"
                                          onClick={() => {
                                            handleEnableDisable(galery._id);
                                          }}
                                        >
                                          <LockIcon
                                            style={{ color: "red" }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    ) : null}
                                    <Tooltip title="Delete">
                                      <IconButton
                                        aria-label="delete"
                                        onClick={() => {
                                          handleOpen(galery._id);
                                        }}
                                      >
                                        <DeleteIcon style={{ color: "red" }} />
                                      </IconButton>
                                    </Tooltip>
                                  </>)}
                            </TableCell>
                          </TableRow>
                        ))
                      : (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              {getAllGallerys?.length > 0 && (
                <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                  <div className="mb-2 mb-md-0">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        min={1}
                        placeholder="Page no."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                      />
                      <div className="goPage cursor-pointer" onClick={handlePageChange}>
                        <h5 className="p-2 m-0">Go</h5>
                      </div>
                    </div>
                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                  </div>
                  {/* {currentPage} */}
                  {/* Pagination in the Center */}
                  <div className="w-100 d-flex justify-content-center mt-5 pb-4">
                    <ReactPaginate
                      pageCount={pageCount} // Replace with the total number of pages
                      pageRangeDisplayed={1}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      previousLabel={pageCount > 1 && currentPage >= 1 ? "Previous" : null}
                      nextLabel={
                        pageCount > 1 && currentPage + 1 !== pageCount ? "Next" : null
                      }
                      // previousLabel={(currentPage + 1) > 1 ? "Previous" : null}
                      // nextLabel={((currentPage + 1) > (totalPages - 1)) ? null : "Next"}
                      disabledClassName={"disablebtn"}
                      forcePage={currentPage}
                    />
                  </div>

                  <div className="mb-2 mb-md-0">
                    <FormControl variant="outlined">
                      <InputLabel></InputLabel>
                      <Select
                        className="itemsperpage"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItemsPerPage(value);
                          setError('');
                          setSearchTerm('');
                          setCurrentPage(0);
                        }}
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              display: 'flex',
                              flexDirection: 'column',
                            },
                          },
                        }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>

                    </FormControl>
                  </div>
                </div>
              )}
              <br />
            </Box>
          </div>
        )
        }
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
        >

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
              Confirmation
            </Typography>
            <IconButton onClick={handleClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </div>
          <Box display="flex" justifyContent="center" width="100%">
            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
          </Box>
          <Typography
            id="modal-modal-title"
            style={{ color: "#611f1e" }}
            variant="h6"
            component="h2"
            className="content-font"
          >
            Are You Surely Want to Delete this Gallery?
          </Typography>
          {/* <Box display="flex" justifyContent="center" width="100%">
                      <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box> */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              className="content-font"
              style={{

                color: "#dc3545",
                border: "1px solid #dc3545",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={handleClose}
            >
              No
            </Button>
            <Button
              className="mx-2 content-font"
              variant="contained"
              style={{
                backgroundColor: "#2e7d32",
                color: "white",
                padding: "5px 15px",
                borderRadius: "0px",
              }}
              onClick={() => handleDelete()}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
    </div >
  );
};

export default GalleryTable;